jQuery(document).foundation();

(function($) {
    $(function() {
        // Button toggler.
        $('button[aria-expanded]').on('click', function() {
            $(this).attr('aria-expanded', function (i, attr) {
                return attr == 'true' ? 'false' : 'true';
            });
            var c = $(this).attr('aria-controls');
            $('#'+c).toggleClass('expanded');
        });
    });
} )( jQuery );